<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid p-1">
        <p class="fs-5 m-2 text-start">
          {{ this.$route.meta.title }}
        </p>
        <div v-if="!userOrders">
          <i class="fas fa-spinner fa-spin fs-1 mt-3"></i>
        </div>
        <div v-else class="row g-0">
          <div class="col-12">
            <div
              class="row g-0 bg-light m-1 m-sm-2 align-items-center rounded shadow p-3"
            >
              <div class="col-1">#</div>
              <div class="col-4 text-decoration-none">تاریخ</div>
              <div class="col-4 text-decoration-none">جمع قیمت</div>
              <div class="col-1">شناسه</div>
              <div class="col-2">جزئیات</div>
            </div>
          </div>
          <template v-for="(item, index) in userOrders" :key="item.id">
            <div class="col-12">
              <div
                class="row g-0 bg-light m-1 m-sm-2 align-items-center rounded shadow p-3"
              >
                <div class="col-1">
                  فاکتور شماره {{ index + 1 }}
                </div>
                <div class="col-4 text-decoration-none">
                  {{ jmoment(item.created_at).format("jYYYY/jMM/jDD") }}
                </div>
                <div class="col-4 text-decoration-none">
                  {{ item.amount }}
                </div>
                <div class="col-1">
                  {{ item.id }}
                </div>
                <div class="col-2">
                  <router-link
                    class="btn btn-theme btn-sm"
                    :to="{ name: 'OrderDetails', params: { orderId: item.id } }"
                  >
                    جزئیات
                  </router-link>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheSidemenu from "../../components/TheSidemenu";
import TheTopmenu from "../../components/TheTopmenu";
import ArefApi from "../../libs/api.js";
import utils from "../../libs/utils";
import jmoment from "moment-jalaali";

export default {
  name: "Orders",
  created() {
    this.arefApi = new ArefApi();
    this.utils = new utils();
    this.jmoment = jmoment;
    this.getUserOrders();
  },
  components: {
    TheSidemenu,
    TheTopmenu,
  },
  data() {
    return {
      userOrders: null,
      API_STORAGE_URL: process.env.VUE_APP_API_STORAGE_URL,
    };
  },
  methods: {
    getUserOrders() {
      this.arefApi
        .getUserOrders()
        .then((resp) => {
          this.userOrders = resp.data;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
  },
};
</script>

